export default {
  PHI: "0",
  NO_PHI: "1",
  NO_PHI_COLORADO: "2",
};